import React from 'react';
import { Link, browserHistory } from 'react-router';
import { header } from 'constants/table';
import {
  DataTable,
  RowItemTinhHinhXuLyDonTaiDonVi,
  RowItemTheoDoiDonDocTheoKy
} from './datatable';
import { DropDownMulipleUse } from 'components/tt-forms';
import { DatePicker, RadioButton, DropDownTreeMultipleSelect } from 'components/tt-forms/common';
import { TheoDoiGiamSat, LetterProcessingWorkFlow } from 'api';
import { ShowIf } from 'components/utils';
import moment from 'moment';
import { Toastr } from 'modules/toastr';
import {
  DropDownChonLoaiNamThongKe,
  DropDownChonLoaiThangThongKe
} from 'components/tt-forms';
import { API_URL } from 'constants/config';
import {downloadFile} from "constants/downloadFile";
import { get, isEmpty } from 'lodash';
import classnames from 'classnames';

class TinhHinhXuLyDonTaiDonVi extends React.Component {
  constructor(props, context) {
    super(props, context);
    const filterTheoKyData = JSON.parse(localStorage.getItem("tdgstk"));
    this.state = {
      data: [],
      id: this.props.id,
      title: 'Tình hình xử lý đơn tại các đơn vị',
      dataPhanHe: [],
      dataTimKiem: [],
      dataLoaiDonThu: [],
      dataListTheoKy: [],
      sum: {
        tongDonDangDaXL: 0,
        tongDonDungHanDaXL: 0,
        tongDonDungHanDangXL: 0,
        tongDonTreHanDaXL: 0,
        tongDonTreHanDangXL: 0
      },
      sumTheoKy: {
        tongDon: 0,
        tongDonDaXLGQ: 0,
        tongDonDangXLGQ: 0,
        tongDonKyTruoc: 0,
        tongDonTrongKy: 0
      },
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      pageDataTheoKy: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      theoDoiDonDoc: localStorage.getItem('tdgs.theoDoiDonDoc') || 'TDDD_XLD_GQD',
      tiepNhanTuNgay: localStorage.getItem('tdgs.tiepNhanTuNgay') ? new Date(localStorage.getItem('tdgs.tiepNhanTuNgay')) : '',
      tiepNhanDenNgay: localStorage.getItem('tdgs.tiepNhanDenNgay') ? new Date(localStorage.getItem('tdgs.tiepNhanDenNgay')) : '',
      year: localStorage.getItem('tdgs.year') ||  moment().format('YYYY'),
      month: localStorage.getItem('tdgs.month') || '',
      phanHe: localStorage.getItem('tdgs.phanHe') || 'XU_LY_DON',
      loaiDonThu: localStorage.getItem('tdgs.loaiDonThu') || '',
      timKiemTheo: localStorage.getItem('tdgs.timKiemTheo') || 'year',
      nguonDon: localStorage.getItem('tdgs.nguonDon') || '',
      coQuanQuanLyFilter: JSON.parse(localStorage.getItem('tdgs.coQuanQuanLyFilter') )|| [],
      filterTheoKy: {
        timKiemTheo: get(filterTheoKyData, 'timKiemTheo', 'year'),
        year: get(filterTheoKyData, 'year', moment().format('YYYY')),
        month: get(filterTheoKyData, 'month', ''),
        tiepNhanTuNgay: get(filterTheoKyData, 'tiepNhanTuNgay') ? new Date(filterTheoKyData.tiepNhanTuNgay) : '',
        tiepNhanDenNgay: get(filterTheoKyData, 'tiepNhanDenNgay') ? new Date(filterTheoKyData.tiepNhanDenNgay) : '',
        loaiDonThu: get(filterTheoKyData, 'loaiDonThu', ''),
        nguonDon: get(filterTheoKyData, 'nguonDon', ''),
        selectedTheoKy: get(filterTheoKyData, 'selectedTheoKy', ''),
        coQuanQuanLyFilter: get(filterTheoKyData, 'coQuanQuanLyFilter', []),
      },
      tableLoading: false,
      searchLoading: false,
      search: false,
      coQuanQuanLyList: [],
      listCoQuanQuanLyTheoKy: [],
      listNguonDon: [],
      acceptDataLoad: true,
      acceptDataLoadTheoKy: true,
      loadingExport: false,
      isSearchDonVi: false,
      isSearchDonViTheoKy: false
    }
  }

  componentDidMount() {
    this.getPhanHe();
    this.getLoaiDonThu();
    this.getListDaTa(this.props.id);
    this.getTypeTimKiem();
    this.getDataTheoKy();
    this.getDataNguonDon();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.id != nextProps.id) {
      this.getListDaTa(nextProps.id);
      this.getDataTheoKy(nextProps.id);
    }
  }

  getDataNguonDon() {
    LetterProcessingWorkFlow.actions.getNguonDon.request().then(res => {
      if (res.data) {
        const result = res.data.filter(item => (item.giaTri !== "GIAO_TTXM" && item.giaTri !== "GIAO_KTDX" && item.giaTri !== "GIAO_TDTH"))
        this.setState({
          listNguonDon: result
        });
      }
    });
  }

  setDataFilterCoQuanQuanLy(data, name = '') {
    if (this.state.acceptDataLoad && name !== 'theoKy') {
      this.setState({
        coQuanQuanLyList: data
      })
    }
    if (this.state.acceptDataLoadTheoKy && name === 'theoKy') {
      this.setState({
        listCoQuanQuanLyTheoKy: data
      })
    }
  }

  getListDaTa(id) {
    let params = {
      quyTrinh: this.state.phanHe,
      phanLoaiDon: this.state.loaiDonThu,
      tiepNhanTuNgay: this.state.tiepNhanTuNgay,
      tiepNhanDenNgay: this.state.tiepNhanDenNgay,
      year: this.state.year,
      month: this.state.month,
      nguonDon: this.state.nguonDon || undefined
    }
    if (!isEmpty(this.state.coQuanQuanLyFilter) && !id) {
      let ids2 = [];
      this.state.coQuanQuanLyFilter.map(item => {
        ids2.push(item.value);
      });
      params.listCoQuanQuanLys = ids2.join();
    }
    if (id) {
      params.donViId = id
    }
    localStorage.setItem('tdgs.phanHe', this.state.phanHe);
    localStorage.setItem('tdgs.loaiDonThu', this.state.loaiDonThu);
    localStorage.setItem('tdgs.timKiemTheo', this.state.timKiemTheo);
    localStorage.setItem('tdgs.tiepNhanTuNgay', this.state.tiepNhanTuNgay);
    localStorage.setItem('tdgs.tiepNhanDenNgay', this.state.tiepNhanDenNgay);
    localStorage.setItem('tdgs.year', this.state.year);
    localStorage.setItem('tdgs.month', this.state.month);
    localStorage.setItem('tdgs.theoDoiDonDoc', this.state.theoDoiDonDoc);
    localStorage.setItem('tdgs.nguonDon', this.state.nguonDon);
    localStorage.setItem('tdgs.coQuanQuanLyFilter', JSON.stringify(this.state.coQuanQuanLyFilter));

    if (this.state.search) {
      if (this.state.tiepNhanTuNgay) {
        params.tuNgay = moment(this.state.tiepNhanTuNgay).add(7,'hours').toISOString();
        localStorage.setItem('tdgs.tiepNhanTuNgay', params.tuNgay);
      }

      if (this.state.tiepNhanDenNgay) {
        params.denNgay = moment(this.state.tiepNhanDenNgay).add(7,'hours').toISOString();
        localStorage.setItem('tdgs.tiepNhanDenNgay', params.denNgay);
      }

      if (this.state.month) {
        params.month = this.state.month;
        localStorage.setItem('tdgs.month', this.state.month);
      }

      if (this.state.year) {
        params.year = this.state.year;
        localStorage.setItem('tdgs.year', this.state.year);
      }

      if (params.tuNgay && params.denNgay && params.tuNgay > params.denNgay) {
        return Toastr('Bạn không được nhập Đến ngày bé hơn Từ ngày', 'error');
      }
    }

    this.setState({
      tableLoading: true,
      searchLoading: true
    });
    if (id) {
      TheoDoiGiamSat.actions.getTinhHinhXuLyDonCacDonViCon.request('',params).then(res => {
        if (res.data) {
          const { donViCha, donVis } = res.data;
          if (!isEmpty(donViCha)) {
            donVis.unshift({
              ...donViCha,
              isDonViCha: true
            });
          }
          this.setState({
            data: donVis,

            title: `Tình hình ${
              localStorage.getItem('tdgs.phanHe') == 'XU_LY_DON' ? 'xử lý đơn' : (
                localStorage.getItem('tdgs.phanHe') == 'GIAI_QUYET_DON' ? 'giải quyết đơn' : (
                  localStorage.getItem('tdgs.phanHe') == 'KIEM_TRA_DE_XUAT' ? 'kiểm tra đề xuất' : (
                    localStorage.getItem('tdgs.phanHe') == 'THAM_TRA_XAC_MINH' ? 'thẩm tra xác minh' : 'xử lý đơn'
                  )
                )
              )
            } trên địa bàn ${get(res, 'data.donViCha.donVi.tenDonVi')}`,
            sum: {
              tongDonDangDaXL: res.data.tongDonDangDaXL ? res.data.tongDonDangDaXL : 0,
              tongDonDungHanDaXL: res.data.tongDonDungHanDaXL ? res.data.tongDonDungHanDaXL : 0,
              tongDonDungHanDangXL: res.data.tongDonDungHanDangXL ? res.data.tongDonDungHanDangXL : 0,
              tongDonTreHanDaXL: res.data.tongDonTreHanDaXL ? res.data.tongDonTreHanDaXL : 0,
              tongDonTreHanDangXL: res.data.tongDonTreHanDangXL ? res.data.tongDonTreHanDangXL : 0,
            },
            tableLoading: false,
            searchLoading: false,
            search: false
          })
        }
      }).catch(error => {
        if (error.response.data.errors) {
          Toastr(error.response.data.errors[0].detail, 'error');
        }
        this.setState({
          tableLoading: false,
          searchLoading: false,
          search: false
        });
      })
    } else {
      TheoDoiGiamSat.actions.getTinhHinhXuLyDonCacDonVi.request('',params).then(res => {
        if (res.data) {
          const { donViCha, donVis } = res.data;
          const listDataDonVi = [...donVis];
          const newDataOption = [];
          listDataDonVi.forEach(item => {
            if (item.donVi.tenDonVi === "Đơn chưa chuyển phòng ban") {
              // Do notthing
            } else {
              newDataOption.push({
                giaTri: get(item, 'donVi.id') || '',
                ten: get(item, 'donVi.tenDonVi') || ''
              })
            }
          });
          if (!isEmpty(donViCha)) {
            donVis.unshift({
              ...donViCha,
              isDonViCha: true
            });
          }
          this.setDataFilterCoQuanQuanLy(newDataOption);
          this.setState({
            data: donVis,
            acceptDataLoad: false,
            isSearchDonVi: isEmpty(donViCha),
            title: `Tình hình ${
              localStorage.getItem('tdgs.phanHe') == 'XU_LY_DON' ? 'xử lý đơn' : (
                localStorage.getItem('tdgs.phanHe') == 'GIAI_QUYET_DON' ? 'giải quyết đơn' : (
                  localStorage.getItem('tdgs.phanHe') == 'KIEM_TRA_DE_XUAT' ? 'kiểm tra đề xuất' : (
                    localStorage.getItem('tdgs.phanHe') == 'THAM_TRA_XAC_MINH' ? 'thẩm tra xác minh' : 'xử lý đơn'
                  )
                )
              )
            } tại các đơn vị`,
            sum: {
              tongDonDangDaXL: res.data.tongDonDangDaXL ? res.data.tongDonDangDaXL : 0,
              tongDonDungHanDaXL: res.data.tongDonDungHanDaXL ? res.data.tongDonDungHanDaXL : 0,
              tongDonDungHanDangXL: res.data.tongDonDungHanDangXL ? res.data.tongDonDungHanDangXL : 0,
              tongDonTreHanDaXL: res.data.tongDonTreHanDaXL ? res.data.tongDonTreHanDaXL : 0,
              tongDonTreHanDangXL: res.data.tongDonTreHanDangXL ? res.data.tongDonTreHanDangXL : 0,
            },
            tableLoading: false,
            searchLoading: false,
            search: false
          })
        }
      }).catch(error => {
        if (error.response.data.errors) {
          Toastr(error.response.data.errors[0].detail, 'error');
        }
        this.setState({
          tableLoading: false,
          searchLoading: false,
          search: false
        });
      })
    }
  }

  getDataTheoKy(id = '') {
    this.setState({
      tableTheoKyLoading: true
    })
    let params = {
      phanLoaiDon: this.state.filterTheoKy.loaiDonThu,
      tuNgay: this.state.filterTheoKy.tiepNhanTuNgay || undefined,
      denNgay: this.state.filterTheoKy.tiepNhanDenNgay || undefined,
      year: this.state.filterTheoKy.year || undefined,
      month: this.state.filterTheoKy.month || undefined,
      nguonDon: this.state.filterTheoKy.nguonDon || undefined,
      ky: this.state.filterTheoKy.selectedTheoKy || undefined
    }
    if (!isEmpty(this.state.filterTheoKy.coQuanQuanLyFilter) && !id) {
      let ids2 = [];
      this.state.filterTheoKy.coQuanQuanLyFilter.map(item => {
        ids2.push(item.value);
      });
      params.listCoQuanQuanLys = ids2.join();
    }
    if (id) {
      params.listCoQuanQuanLys = id
    }
    const dataLocal = {
      loaiDonThu: this.state.filterTheoKy.loaiDonThu,
      timKiemTheo: this.state.filterTheoKy.timKiemTheo,
      tiepNhanTuNgay: this.state.filterTheoKy.tiepNhanTuNgay,
      tiepNhanDenNgay: this.state.filterTheoKy.tiepNhanDenNgay,
      year: this.state.filterTheoKy.year,
      month: this.state.filterTheoKy.month,
      selectedTheoKy: this.state.filterTheoKy.selectedTheoKy,
      nguonDon: this.state.filterTheoKy.nguonDon,
      coQuanQuanLyFilter: this.state.filterTheoKy.coQuanQuanLyFilter
    }
    localStorage.setItem('tdgstk', JSON.stringify(dataLocal))
    if (this.state.filterTheoKy.timKiemTheo === 'day') {
      if (this.state.filterTheoKy.tiepNhanTuNgay) {
        params.tuNgay = moment(this.state.filterTheoKy.tiepNhanTuNgay).add(7,'hours').toISOString();
      }
      if (this.state.filterTheoKy.tiepNhanDenNgay) {
        params.denNgay = moment(this.state.filterTheoKy.tiepNhanDenNgay).add(7,'hours').toISOString();
      }
      params.month = undefined;
      params.year = undefined;
    }
    if (this.state.filterTheoKy.timKiemTheo === 'month') {
      params.tuNgay = undefined;
      params.denNgay = undefined;
      if (this.state.filterTheoKy.month) {
        params.month = this.state.filterTheoKy.month;
      }
    }
    if (this.state.filterTheoKy.timKiemTheo === 'year') {
      params.tuNgay = undefined;
      params.denNgay = undefined;
      params.month = undefined;
      if (this.state.filterTheoKy.year) {
        params.year = this.state.filterTheoKy.year;
      }
    }

    if (params.tuNgay && params.denNgay && params.tuNgay > params.denNgay) {
      return Toastr('Bạn không được nhập Đến ngày bé hơn Từ ngày', 'error');
    }

    TheoDoiGiamSat.actions.getTinhHinhXuLyDonCacDonViTheoKy.request('', params).then(res => {
      if (!isEmpty(res.data)) {
        const { donViCha, donVis } = res.data;
        const listDataDonVi = [...donVis];
          const newDataOption = [];
          listDataDonVi.forEach(item => {
            if (item.donVi.tenDonVi === "Đơn chưa chuyển phòng ban") {
              // Do notthing
            } else {
              newDataOption.push({
                giaTri: get(item, 'donVi.id') || '',
                ten: get(item, 'donVi.tenDonVi') || ''
              })
            }
          });
        if (!isEmpty(donViCha)) {
          donVis.unshift({
            ...donViCha,
            isDonViCha: true
          });
        }
        this.setDataFilterCoQuanQuanLy(newDataOption, 'theoKy');
        this.setState({
          dataListTheoKy: donVis,
          acceptDataLoadTheoKy: false,
          isSearchDonViTheoKy: isEmpty(donViCha),
          sumTheoKy: {
            tongDon: res.data.tongDon || 0,
            tongDonDaXLGQ: res.data.tongDonDaXLGQ || 0,
            tongDonDangXLGQ: res.data.tongDonDangXLGQ || 0,
            tongDonKyTruoc: res.data.tongDonKyTruoc || 0,
            tongDonTrongKy: res.data.tongDonTrongKy || 0
          }
        })
      }
    }).catch(error => {
      console.error(error);
    }).finally(() => {
      this.setState({
        tableTheoKyLoading: false
      })
    })
  }

  getPhanHe() {
    TheoDoiGiamSat.actions.getPhanHe.request('').then(res => {
      if (res.data) {
        this.setState({
          dataPhanHe: res.data
        })
      }
    })
  }

  getLoaiDonThu() {
    TheoDoiGiamSat.actions.getLoaiDonThu.request('').then(res => {
      if (res.data) {
        const listData = res.data.filter(item => item.giaTri !== "DON_TO_CAO");
        this.setState({
          dataLoaiDonThu: listData
        });
      }
    });
  }

  getTypeTimKiem() {
    TheoDoiGiamSat.actions.getTypeTimKiem.request('').then(res => {
      if (res.data) {
        this.setState({
          dataTimKiem: res.data
        });
      }
    });
  }

  onChange(name, e) {
    if (name == 'timKiemTheo') {
      this.resetParams();
    }
    if (this.state.theoDoiDonDoc === 'TDDD_XLD_GQD') {
      this.setState({
        [name]: name === 'coQuanQuanLyFilter' ? e : e.target.value
      });
    } else {
      this.setState({
        filterTheoKy: {
          ...this.state.filterTheoKy,
          [name]: name === 'coQuanQuanLyFilter' ? e : e.target.value
        }
      });
    }
  }

  resetParams() {
    localStorage.removeItem('tdgstk');
    this.setState({
      tiepNhanTuNgay: '',
      tiepNhanDenNgay: '',
      year: '',
      month: '',
      phanHe: 'XU_LY_DON',
      loaiDonThu: 'DON_KHIEU_NAI',
      filterTheoKy: {
        ...this.state.filterTheoKy,
        tiepNhanTuNgay: '',
        tiepNhanDenNgay: '',
        year: '',
        month: '',
        loaiDonThu: 'DON_KHIEU_NAI',
      }
    });
    localStorage.removeItem('tdgs.tiepNhanTuNgay');
    localStorage.removeItem('tdgs.tiepNhanDenNgay');
    localStorage.removeItem('tdgs.year');
    localStorage.removeItem('tdgs.month');
    localStorage.removeItem('tdgs.phanHe');
    localStorage.removeItem('tdgs.loaiDonThu');
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });
    return pass;
  }

  componentWillUnmount() {

  }

  handleSearch(e) {
    e.preventDefault();
    if (this.validateSubmitForm()) {
      this.setState({
        search: true
      }, () => {
        if (this.state.theoDoiDonDoc === 'TDDD_XLD_GQD') {
          this.getListDaTa(this.props.id);
        } else {
          this.getDataTheoKy();
        }
      })
    }
    return;
  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      if (this.state.theoDoiDonDoc === 'TDDD_XLD_GQD') {
        this.setState({
          [name]: e._d
        });
      } else {
        this.setState({
          filterTheoKy: {
            ...this.state.filterTheoKy,
            [name]: e._d
          }
        });
      }
    } else {
      if (this.state.theoDoiDonDoc === 'TDDD_XLD_GQD') {
        this.setState({
          [name]: e
        });
      } else {
        this.setState({
          filterTheoKy: {
            ...this.state.filterTheoKy,
            [name]: e
          }
        });
      }
    }
  }

  handleExportExcel() {
    this.setState({
      loadingExport: true
    })
    const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    if (this.state.theoDoiDonDoc === 'TDDD_KY') {
      try {
        let URL = String(API_URL) + "/theoDoiGiamSatTheoKys/tinhHinhXuLyDonTaiCacDonVi/xuatExcel?"
        + "phanLoaiDon=" + this.state.filterTheoKy.loaiDonThu

        if (this.state.filterTheoKy.selectedTheoKy) {
          URL = URL + "&ky=" + this.state.filterTheoKy.selectedTheoKy;
        }
        if (!isEmpty(this.state.filterTheoKy.nguonDon)) {
          URL = URL + "&nguonDon=" + this.state.filterTheoKy.nguonDon
        }
        if (this.state.filterTheoKy.timKiemTheo === 'day') {
          if (get(this.state.filterTheoKy, 'tiepNhanTuNgay')) {
            URL = URL + "&tuNgay=" + moment(this.state.filterTheoKy.tiepNhanTuNgay).add(7,'hours').toISOString();
          }
          if (get(this.state.filterTheoKy, 'tiepNhanDenNgay')) {
            URL = URL + "&denNgay=" + moment(this.state.filterTheoKy.tiepNhanDenNgay).add(7,'hours').toISOString();
          }
        }
        if (this.state.filterTheoKy.timKiemTheo === 'month') {
          URL = URL + "&month=" + this.state.filterTheoKy.month;
          URL = URL + "&year=" + this.state.filterTheoKy.year;
        }
        if (this.state.filterTheoKy.timKiemTheo === 'year') {
          URL = URL + "&year=" + this.state.filterTheoKy.year;
        }
        if (!isEmpty(this.state.filterTheoKy.coQuanQuanLyFilter)) {
          let ids2 = [];
          this.state.filterTheoKy.coQuanQuanLyFilter.map(item => {
            ids2.push(item.value);
          });
          URL = URL + "&listCoQuanQuanLys=" + ids2.join();
        }
        downloadFile(URL);
        return ;
      } catch (error) {

      } finally {
        setTimeout(function () {
          this.setState({
            loadingExport: false
          });
        }.bind(this), 3000);
      }
    }
    if (this.props.id) {
      try {
        let URL = String(API_URL) + "/theoDoiGiamSats/tinhHinhXuLyDonTaiCacDonViCon/xuatExcel?"
        + "month=" + this.state.month
        + "&year=" + this.state.year
        + "&donViId=" + this.props.id
        + "&phanLoaiDon=" + this.state.loaiDonThu
        + "&quyTrinh=" + this.state.phanHe

        if (this.state.tiepNhanTuNgay) {
          URL = URL + "&tuNgay=" + moment(this.state.tiepNhanTuNgay).add(7,'hours').toISOString()
        }
        if (this.state.tiepNhanDenNgay) {
          URL = URL + "&denNgay=" + moment(this.state.tiepNhanDenNgay).add(7,'hours').toISOString()
        }
        downloadFile(URL);
        return ;
      } catch (error) {

      } finally {
        setTimeout(function () {
          this.setState({
            loadingExport: false
          });
        }.bind(this), 3000);
      }
    } else {
      try {
        let URL = String(API_URL) + "/theoDoiGiamSats/tinhHinhXuLyDonTaiCacDonVi/xuatExcel?"
        + "month=" + this.state.month
        + "&year=" + this.state.year
        + "&quyTrinh=" + this.state.phanHe
        + "&phanLoaiDon=" + this.state.loaiDonThu
        + "&capCoQuanQuanLyId=" + userInfo.capCoQuanQuanLyId
        + "&coQuanQuanLyId=" + userInfo.coQuanQuanLyId
        + "&donViId=" + userInfo.donViId

        if (!isEmpty(this.state.coQuanQuanLyFilter)) {
          let ids2 = [];
          this.state.coQuanQuanLyFilter.map(item => {
            ids2.push(item.value);
          });
          URL = URL + "&listCoQuanQuanLys=" + ids2.join();
        }
        if (this.state.nguonDon) {
          URL = URL + "&nguonDon=" + this.state.nguonDon
        }
        if (this.state.tiepNhanTuNgay) {
          URL = URL + "&tuNgay=" + moment(this.state.tiepNhanTuNgay).add(7,'hours').toISOString()
        }
        if (this.state.tiepNhanDenNgay) {
          URL = URL + "&denNgay=" + moment(this.state.tiepNhanDenNgay).add(7,'hours').toISOString()
        }
        downloadFile(URL);
        return ;
      } catch (error) {

      } finally {
        setTimeout(function () {
          this.setState({
            loadingExport: false
          });
        }.bind(this), 3000);
      }
    }
  }

  onChangeSelectedRadio(e) {
    const { value } = e.target;
    this.setState({
      theoDoiDonDoc: value
    })
    localStorage.setItem('tdgs.theoDoiDonDoc', value);
  }

  getStateTheoDoiDonDoc(name) {
    let state = this.state;
    if (this.state.theoDoiDonDoc === 'TDDD_KY') {
      state = this.state.filterTheoKy;
    }
    return state[name];
  }

  render() {
    const dataSelectTheoKy = [
      {
        ten: "Tất cả",
        giaTri: ''
      },
      {
        ten: "Trong kỳ",
        giaTri: 'TRONGKY'
      },
      {
        ten: "Kỳ trước chuyển sang",
        giaTri: 'KYTRUOC'
      }
    ];
    const data = [
      {
        ten: 'THEO DÕI ĐÔN ĐỐC THEO XLĐ, GQĐ',
        giaTri: 'TDDD_XLD_GQD'
      },
      {
        ten: 'THEO DÕI ĐÔN ĐỐC THEO KỲ',
        giaTri: 'TDDD_KY'
      }
    ];
    return (
      <div className="center reception-container">
        {
          this.props.id ? (
            <div className="back-foward mb0">
              <Link onClick={ browserHistory.goBack } title="">Về trang trước</Link>
            </div>
          ) : (
            null
          )
        }
        <div className="top-content">
          <div className="left-content">
            <RadioButton
              options={data}
              selectedValue={this.state.theoDoiDonDoc}
              keyName='giaTri'
              valueName='ten'
              onChange={this.onChangeSelectedRadio.bind(this)} />
          </div>
        </div>
        <div className="bottom-content">
          <form className={classnames('wrap-block pl15 pr15 pt20', {'wrap-block-xldtdv': this.getStateTheoDoiDonDoc('timKiemTheo') !== 'year'})} onSubmit={this.handleSearch.bind(this)}>
            <div>
              <div className="row pl10 pr10">
                <div className="col-60">
                  <DropDownMulipleUse className="col-4" placeholder={null} label='Tìm kiếm theo' data={this.state.dataTimKiem} keyName='giaTri' valueName='ten' selectedValue={this.getStateTheoDoiDonDoc('timKiemTheo')} onChange={this.onChange.bind(this, 'timKiemTheo')}/>
                  <ShowIf condition={this.getStateTheoDoiDonDoc('timKiemTheo') == 'day'}>
                    <DatePicker require className="col-4" label='Từ ngày' bindValidator={this} channel="formTaoDon" endDate={this.getStateTheoDoiDonDoc('tiepNhanDenNgay')} onChange={ this.handleChangeDate.bind(this, 'tiepNhanTuNgay')} value={this.getStateTheoDoiDonDoc('tiepNhanTuNgay')} />
                    <DatePicker require className="col-4" label='Đến ngày' bindValidator={this} channel="formTaoDon" startDate={this.getStateTheoDoiDonDoc('tiepNhanTuNgay')} onChange={ this.handleChangeDate.bind(this, 'tiepNhanDenNgay')} value={this.getStateTheoDoiDonDoc('tiepNhanDenNgay')} />
                  </ShowIf>
                  <ShowIf condition={this.getStateTheoDoiDonDoc('timKiemTheo') == 'month'}>
                    <DropDownChonLoaiThangThongKe require bindValidator={this} className="col-4" onChange={this.onChange.bind(this, 'month')} selectedValue={this.getStateTheoDoiDonDoc('month')}/>
                    <DropDownChonLoaiNamThongKe require bindValidator={this} className="col-4" onChange={this.onChange.bind(this, 'year')} selectedValue={this.getStateTheoDoiDonDoc('year')}/>
                  </ShowIf>
                  <ShowIf condition={this.getStateTheoDoiDonDoc('timKiemTheo') == 'year'}>
                    <DropDownChonLoaiNamThongKe require bindValidator={this} className="col-4" onChange={this.onChange.bind(this, 'year')} selectedValue={this.getStateTheoDoiDonDoc('year')}/>
                  </ShowIf>
                  {
                    this.state.theoDoiDonDoc === "TDDD_XLD_GQD" &&
                    <DropDownMulipleUse className="col-4" placeholder={null} label="Phân hệ" data={this.state.dataPhanHe} keyName="giaTri" valueName="ten" selectedValue={this.state.phanHe} onChange={this.onChange.bind(this, 'phanHe')}/>
                  }
                  <DropDownMulipleUse className="col-4" placeholder={null} label="Loại đơn thư" data={this.state.dataLoaiDonThu} keyName="giaTri" valueName="ten" selectedValue={this.getStateTheoDoiDonDoc('loaiDonThu')} onChange={this.onChange.bind(this, 'loaiDonThu')}/>
                  {
                    this.state.theoDoiDonDoc !== "TDDD_XLD_GQD" &&
                    <DropDownMulipleUse className="col-4" placeholder={null} label="Kỳ báo cáo" data={dataSelectTheoKy} keyName="giaTri" valueName="ten" selectedValue={this.state.filterTheoKy.selectedTheoKy} onChange={this.onChange.bind(this, 'selectedTheoKy')}/>
                  }
                  <DropDownMulipleUse  className="col-4" label="Nguồn đơn" data={this.state.listNguonDon} keyName="giaTri" valueName="ten" selectedValue={this.getStateTheoDoiDonDoc('nguonDon')} onChange={this.onChange.bind(this, 'nguonDon')}/>
                  {
                    !this.props.id &&
                    <DropDownTreeMultipleSelect className="col-8" label="Đơn vị" dataOptions={this.state.theoDoiDonDoc === 'TDDD_XLD_GQD' ? this.state.coQuanQuanLyList : this.state.listCoQuanQuanLyTheoKy} dataSelected={this.getStateTheoDoiDonDoc('coQuanQuanLyFilter')} onChange={this.onChange.bind(this, 'coQuanQuanLyFilter')} propertyParent="giaTri"/>
                  }
                </div>
                <div className='col-40'>
                  <div className="rows">
                    <div className="search-thanh-tra col-6">
                      <button
                        className={this.state.searchLoading ? (this.state.search ? 'btn-loading-inline btn-disable btn-green' : 'btn-disable btn-green') : 'btn-green'}
                        type='submit'
                        disabled={ this.state.searchLoading ? 'disabled' : '' }
                      ><i className='tt-search'></i>Xem kết quả</button>
                    </div>
                    <div className="col-6 search-thanh-tra">
                      <Link
                        className={classnames('btn-green tt-export', {'btn-loading-inline': this.state.loadingExport})}
                        onClick={this.handleExportExcel.bind(this)}
                      >
                        Xuất danh sách
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='row'>
              <span className="line-border"></span>
            </div>
          </form>
          {
            this.state.theoDoiDonDoc === 'TDDD_XLD_GQD' ?
            <DataTable hiddenSum header={header.theoDoi.tinhHinhXLDDonVi} numberColumnHeader={7} theoDoiGiamSat={true} dataList={this.state.data} hidePagination={true} hideButtonExport={true} pageData={this.state.pageData} parent={this} search={this.state.search}
            tableLoading={this.state.tableLoading} {...this.state.sum}>
              <RowItemTinhHinhXuLyDonTaiDonVi isSearchDonVi={this.state.isSearchDonVi}/>
            </DataTable> :
            <DataTable
              hiddenSum
              header={header.theoDoi.theoDoiDonDocTheoKy}
              numberColumnHeader={7}
              theoDoiGiamSat
              dataList={this.state.dataListTheoKy}
              hidePagination
              hideButtonExport
              theoDoiDonDocTheoKy
              pageData={this.state.pageData}
              parent={this}
              search={this.state.search}
              tableLoading={this.state.tableTheoKyLoading}
              {...this.state.sumTheoKy}
            >
              <RowItemTheoDoiDonDocTheoKy isSearchDonVi={this.state.isSearchDonViTheoKy}/>
            </DataTable>
          }
        </div>
      </div>
    );
  }
}

TinhHinhXuLyDonTaiDonVi.defaultProps = {
  validators: {
    formTaoDon: []
  }
}

export default TinhHinhXuLyDonTaiDonVi;



// WEBPACK FOOTER //
// ./src/components/modules/theo-doi-giam-sat/TinhHinhXuLyDonTaiDonVi.jsx